import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { RiDeleteBin6Line, RiEditLine, RiMoreFill } from 'react-icons/ri';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import { UPDATE_STAFF_LOGIN_STATUS } from 'pages/Staff/StaffgraphQL';

const ActionDropdown = (props) => {
  const {
    handleDelete,
    handleAddEditRecord,
    keyValue,
    loginEnabled,
    hideLoginToggle,
  } = props;
  const [isLoginEnabled, setIsLoginEnabled] = useState(Boolean(loginEnabled));
  const [updateStaffLoginStatus, { loading: updatingLoginStatus }] =
    useMutation(UPDATE_STAFF_LOGIN_STATUS);

  useEffect(() => {
    setIsLoginEnabled(Boolean(loginEnabled));
  }, [loginEnabled]);

  const handleLoginStatusChange = async () => {
    const nextStatus = !isLoginEnabled;

    try {
      await updateStaffLoginStatus({
        variables: {
          userId: keyValue,
          loginEnabled: nextStatus,
        },
      });
      setIsLoginEnabled(nextStatus);
      toast.success(
        `Staff login ${nextStatus ? 'enabled' : 'disabled'} successfully.`,
      );
    } catch (error) {
      toast.error(error?.message || 'Unable to update staff login status.');
    }
  };

  return (
    <UncontrolledDropdown className="action-dropdown">
      <DropdownToggle
        color="link"
        className="text-decoration-none p-0 text-active"
      >
        <RiMoreFill size={20} color="#525252" />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem
          className="d-flex align-items-center f-12 mb-1"
          onClick={handleAddEditRecord}
        >
          <RiEditLine size={18} className="me-1" /> Edit
        </DropdownItem>
        <DropdownItem
          className="d-flex align-items-center f-12"
          onClick={() => handleDelete(keyValue)}
        >
          <RiDeleteBin6Line size={16} className="me-1" /> Delete
        </DropdownItem>
        {!hideLoginToggle && (
          <DropdownItem
            className="staff-login-toggle-item d-flex align-items-center justify-content-between f-12"
            onClick={handleLoginStatusChange}
            disabled={updatingLoginStatus}
            title={isLoginEnabled ? 'Disable staff login' : 'Enable staff login'}
          >
            <span>Login</span>
            <span className="staff-login-toggle" aria-hidden="true">
              <input type="checkbox" checked={isLoginEnabled} readOnly />
              <span className="staff-login-toggle-slider" />
            </span>
          </DropdownItem>
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default ActionDropdown;
